// choices/lightChoices.js
const lightChoicesRo = [
  {
    label: "Lumină naturală",
    value: "natural",
  },
  {
    label: "Lumină artificială",
    value: "artificial",
  },

  {
    label: "Iluminat mixt",
    value: "mixed",
  },
];

export default lightChoicesRo;
